<nz-space class="mobile-report-control">
  <app-aprefund-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
    valueField="docCode">
  </app-aprefund-select>
  <span class="text-center">
    <span nz-icon nzType="swap-right" nzTheme="outline"></span>
  </span>
  <app-aprefund-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="docCode">
  </app-aprefund-select>
</nz-space>
